import React from 'react';

var Captcha = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var setWord = _ref.setWord,
      _ref$numberOfCharacte = _ref.numberOfCharacters,
      numberOfCharacters = _ref$numberOfCharacte === void 0 ? 4 : _ref$numberOfCharacte,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#0c0c0c' : _ref$backgroundColor,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? '#fff' : _ref$fontColor,
      _ref$persianChars = _ref.persianChars,
      persianChars = _ref$persianChars === void 0 ? false : _ref$persianChars,
      _ref$reloadText = _ref.reloadText,
      reloadText = _ref$reloadText === void 0 ? 'Reload Captcha' : _ref$reloadText,
      reloadEl = _ref.reloadEl,
      inputEl = _ref.inputEl;
  var canvas = React.useRef(null);
  var charset = persianChars ? 'ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی' : 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var length = parseInt(numberOfCharacters);
  var initializeCaptcha = React.useCallback(function () {
    var retVal = '';
    var captcha = '';

    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }

    if (persianChars) {
      captcha = retVal.split('').reverse().join('');
    } else {
      captcha = retVal;
    }

    setWord(captcha);
    var canvasEl = canvas.current;
    var ctx = canvasEl.getContext('2d');

    if (ctx === null) {
      console.error('no ctx');
      return;
    }

    var text = captcha;
    var lineheight = 30;
    var lines = text.split('\n');
    ctx.canvas.width = length * 25;
    ctx.canvas.height = lines.length * lineheight;
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);
    ctx.textBaseline = 'middle';
    ctx.font = 'italic 20px Arial';
    ctx.fillStyle = fontColor;
    var num = 0;

    for (var _i = 0; _i < length; _i++) {
      num = num + 1;
      var heigt_num = 20 * num;
      ctx.fillText(retVal[_i], heigt_num, Math.round(Math.random() * (15 - 12) + 12));
    }
  }, [backgroundColor, charset, fontColor, length, persianChars, setWord]);
  React.useImperativeHandle(ref, function () {
    return {
      initializeCaptcha: initializeCaptcha
    };
  });
  React.useEffect(function () {
    initializeCaptcha();
  }, [initializeCaptcha]);
  return React.createElement("div", null, React.createElement("canvas", {
    ref: canvas,
    width: 100,
    height: 100
  }), React.createElement("div", null, reloadEl != null ? reloadEl : React.createElement("span", {
    id: "reload_href",
    style: {
      cursor: 'pointer',
      backgroundColor: backgroundColor,
      color: fontColor
    },
    onClick: initializeCaptcha
  }, reloadText)), inputEl);
});

export { Captcha };
//# sourceMappingURL=react-captcha.esm.js.map
